<template>
  <div class="edit-ubicazione" style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Articoli Ubicazione</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="nuovoArticolo">
              <v-icon color="#1a80b6"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Crea Articolo</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="salvaUbicazione"
            >
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva Ubicazione</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="toggleFilters">
              <v-icon v-if="!showFiltri" color="purple"> mdi-filter </v-icon>
              <v-icon v-if="showFiltri" color="purple"> mdi-filter-off </v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="
                $router.push({
                  name: 'edit-magazzino',
                  params: { id: idMagazzino, duplicateId: duplicateId },
                })
              "
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-card-text>
        <v-row v-if="showFiltri">
          <v-col>
            <v-autocomplete
              label="codice"
              dense
              outlined
              v-model="filtroCod"
              :items="codici"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              label="descrizione"
              dense
              outlined
              v-model="filtroDes"
              :items="descrizioni"
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="
                ubicazioneArticoli.filter(
                  (e) =>
                    (!this.showFiltri ||
                      ((this.filtroCod == 'tutti' ||
                        e.cod_articolo.includes(this.filtroCod)) &&
                        (this.filtroDes == 'tutti' ||
                          e.des_articolo.includes(this.filtroDes)))) &&
                    e.validita == 1
                )
              "
            >
              <template v-slot:[`item.buttons`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      class="ma-1"
                      @click="modificaArticolo(item)"
                    >
                      <v-icon color="#1a80b6"> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica</span>
                </v-tooltip>

              </template>

              <template v-slot:[`item.divieto`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      class="ma-1"
                      @click="forbid(item)"
                    >
                      <v-icon :color="item.divieto ? 'error' : 'success'">
                        {{ item.divieto ? "mdi-cancel" : "mdi-thumb-up" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Proibire</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.tipo`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      class="ma-3"
                      @click="changeType(item)"
                    >
                      <v-icon :color="item.tipo ? 'success' : 'orange'">{{
                        item.tipo ? "mdi-cart" : "mdi-download"
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    item.tipo ? "Ubicazione Picking" : "Ubicazione Refilling"
                  }}</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.delete`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="deleteArticolo(item)"
                    >
                      <v-icon class="error--text">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogArticoloVisible" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            {{ dialogTitle }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small @click="saveArticolo">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Inserisci</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="chiudiDialogArticolo" small>
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-autocomplete
                :readonly="dialogModify"
                label="codice"
                dense
                outlined
                v-model="tempArticolo"
                :items="articoli"
                item-text="cod_articolo"
                return-object
                append-outer-icon="mdi-magnify"
                @click:append-outer="searchArticolo"
                @keydown.enter="searchArticolo"
                id="artsch"
              >
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-text-field
                readonly
                label="peso"
                dense
                outlined
                v-model="tempArticolo.peso_netto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                readonly
                label="descrizione"
                dense
                outlined
                v-model="tempArticolo.des_articolo"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-text-field
                label="quantita refilling"
                dense
                outlined
                type="number"
                v-model="tempArticolo.quantita"
              >
              </v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                label="quantita minima"
                dense
                outlined
                type="number"
                v-model="tempArticolo.quantita_min"
              >
              </v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                label="quantita massima"
                dense
                outlined
                type="number"
                v-model="tempArticolo.quantita_max"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogElimina"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text">
            Eliminazione Articolo
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di voler eliminare questo articolo dall'ubicazione
            attuale?
          </h3>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialogElimina = false">
            ANNULLA
          </v-btn>
          <v-btn color="#1a80b6" dark @click="confirmDelete"> CONFERMA </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "editUbicazione",
  props: ["id", "idMagazzino", "duplicateId"],
  components: {
    SnackbarQV,
  },
  data() {
    return {
      loading: false,
      nextTempId: 0,
      dialogTitle: "",
      dialogElimina: false,
      dialogModify: false,
      filtroCod: "tutti",
      filtroDes: "tutti",
      showFiltri: false,
      tempArticolo: {
        des_articolo: "",
        peso_netto: "",
        immagine_preview: "",
        quantita: 0,
      },
      articoli: [],
      codici: ["tutti"],
      descrizioni: ["tutti"],
      ubicazioneArticoli: [],
      dialogArticoloVisible: false,
      headers: [
        {
          text: "",
          value: "buttons",
          sortable: false,
        },
        {
          text: "Permesso",
          value: "divieto",
        },
        {
          text: "Tipo",
          value: "tipo",
        },
        {
          text: "Codice",
          value: "cod_articolo",
        },
        {
          text: "Descrizione",
          value: "des_articolo",
        },
        {
          text: "Peso",
          value: "peso_netto",
        },
        {
          text: "Quantita Refilling",
          value: "quantita",
        },
        {
          text: "Quantita minima",
          value: "quantita_min",
        },
        {
          text: "Quantita Massima",
          value: "quantita_max",
        },
        {
          text: "",
          value: "delete",
          sortable: false,
        },
      ],
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.inizializza();
  },
  methods: {
    inizializza() {
      this.loading = true;

      let request2 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoliubicazione",
          id_ubicazione: this.id,
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request2).then(async (res) => {
        if (res.status == 200) {
          if (res.data != undefined) {
            if (res.data.result.articoli.length > 0) {
              for (let i = 0; i < res.data.result.articoli.length; i++) {
                this.ubicazioneArticoli.push(
                  Object.assign({}, res.data.result.articoli[i])
                );
              }
              this.getFilters();
            }
          }
          this.loading = false;
        }
      });

      /*let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          if (res.data != undefined) {
            this.articoli = res.data.lista;
          }
        }
        this.loading = false;
      });*/
    },
    searchArticolo() {
      this.loading = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          cod_articolo: "*" + document.getElementById("artsch").value + "*",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          if (res.data != undefined) {
            this.articoli = res.data.lista;
          }
        }
        this.loading = false;
      });
    },
    toggleFilters() {
      this.showFiltri = !this.showFiltri;
    },
    getFilters() {
      this.codici = ["tutti"];
      this.descrizioni = ["tutti"];
      if (this.ubicazioneArticoli.length > 0) {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (this.ubicazioneArticoli[i].validita == 1) {
            if (
              this.ubicazioneArticoli[i].cod_articolo != undefined &&
              !this.codici.includes(this.ubicazioneArticoli[i].cod_articolo)
            ) {
              this.codici.push(this.ubicazioneArticoli[i].cod_articolo);
            }
            if (
              this.ubicazioneArticoli[i].des_articolo != undefined &&
              !this.descrizioni.includes(
                this.ubicazioneArticoli[i].des_articolo
              )
            ) {
              this.descrizioni.push(this.ubicazioneArticoli[i].des_articolo);
            }
          }
        }
      }
    },
    saveArticolo() {
      if (this.dialogModify) {
        if (this.tempArticolo.id_articolo_ubicazione == -1) {
          for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
            if (this.ubicazioneArticoli[i].tempid == this.tempArticolo.tempid) {
              this.ubicazioneArticoli[i] = Object.assign({}, this.tempArticolo);
              break;
            }
          }
        } else {
          for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
            if (
              this.ubicazioneArticoli[i].id_articolo_ubicazione ==
              this.tempArticolo.id_articolo_ubicazione
            ) {
              this.ubicazioneArticoli[i] = Object.assign({}, this.tempArticolo);
              break;
            }
          }
        }
      } else {
        this.ubicazioneArticoli.push({
          id_magazzino_ubicazione: this.id,
          id_articolo: this.tempArticolo.id_articolo,
          cod_articolo: this.tempArticolo.cod_articolo,
          des_articolo: this.tempArticolo.des_articolo,
          quantita: this.tempArticolo.quantita,
          quantita_min: this.tempArticolo.quantita_min,
          quantita_max: this.tempArticolo.quantita_max,
          peso_netto: this.tempArticolo.peso_netto,
          immagine_preview: this.tempArticolo.immagine_preview,
          id_articolo_ubicazione: -1,
          tempid: this.nextTempId,
          divieto: false,
          validita: 1,
        });
        this.nextTempId++;
      }
      this.getFilters();
      this.$refs.SnackbarQV.print("success", "Articolo salvato con successo");
    },
    nuovoArticolo() {
      this.dialogModify = false;
      this.dialogTitle = "Inserimento Articolo";
      this.dialogArticoloVisible = true;
    },
    modificaArticolo(item) {
      this.dialogModify = true;
      this.tempArticolo = Object.assign({}, item);
      this.dialogTitle = "Modifica Articolo";
      this.dialogArticoloVisible = true;
    },
    chiudiDialogArticolo() {
      this.dialogArticoloVisible = false;
    },
    deleteArticolo(item) {
      this.tempArticolo = Object.assign({}, item);
      this.dialogElimina = true;
    },
    confirmDelete() {
      if (this.tempArticolo.id_articolo_ubicazione == -1) {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (this.ubicazioneArticoli[i].tempid == this.tempArticolo.tempid) {
            this.ubicazioneArticoli[i].validita = 0;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (
            this.ubicazioneArticoli[i].id_articolo_ubicazione ==
            this.tempArticolo.id_articolo_ubicazione
          ) {
            this.ubicazioneArticoli[i].validita = 0;
            break;
          }
        }
      }
      this.getFilters();
      this.$refs.SnackbarQV.print("success", "Articolo eliminato con successo");
      this.dialogElimina = false;
    },
    changeType(item) {
      if (item.id_articolo_ubicazione == -1) {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (this.ubicazioneArticoli[i].tempid == item.tempid) {
            this.ubicazioneArticoli[i].tipo = !this.ubicazioneArticoli[i].tipo;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (
            this.ubicazioneArticoli[i].id_articolo_ubicazione ==
            item.id_articolo_ubicazione
          ) {
            this.ubicazioneArticoli[i].tipo = !this.ubicazioneArticoli[i].tipo;
            break;
          }
        }
      }
      this.$forceUpdate();
    },
    forbid(item) {
      if (item.id_articolo_ubicazione == -1) {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (this.ubicazioneArticoli[i].tempid == item.tempid) {
            this.ubicazioneArticoli[i].divieto =
              !this.ubicazioneArticoli[i].divieto;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.ubicazioneArticoli.length; i++) {
          if (
            this.ubicazioneArticoli[i].id_articolo_ubicazione ==
            item.id_articolo_ubicazione
          ) {
            this.ubicazioneArticoli[i].divieto =
              !this.ubicazioneArticoli[i].divieto;
            break;
          }
        }
      }
      this.$forceUpdate();
    },
    salvaUbicazione() {
      this.loading = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticoliubicazione",
          ubicazione: this.ubicazioneArticoli,
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print(
            "success",
            "Ubicazione salvato con successo"
          );
        } else {
          this.$refs.SnackbarQV.print("error", "Ubicazione non salvato");
        }
        this.loading = false;
      });
    },
  },
};
</script>